// Calculate spread number and page position from page number
export function getSpreadAndPageInfo(page, totalPages) {
  // Handle front cover
  if (page === 0) {
    return {
      spreadNumber: 0,
      isRightPage: true,
    };
  }

  // Handle back cover
  if (page === totalPages + 1) {
    return {
      spreadNumber: Math.ceil((totalPages + 1) / 2),
      isRightPage: false,
    };
  }

  // Handle content pages (1 to totalPages)
  const spreadNumber = Math.ceil(page / 2);
  const isRightPage = page % 2 === 0;

  return {
    spreadNumber,
    isRightPage,
  };
}

// Get the actual page number for a given spread and side
export function getPageNumber(spreadNumber, isRightPage, totalPages) {
  // Handle front cover spread
  if (spreadNumber === 0) {
    return isRightPage ? 0 : 1;
  }

  // Calculate the base page number
  const basePage = spreadNumber * 2;

  // Handle back cover spread
  if (spreadNumber === Math.ceil((totalPages + 1) / 2)) {
    return isRightPage ? totalPages : totalPages + 1;
  }

  // Handle regular content spreads
  return isRightPage ? basePage : basePage - 1;
}
